export const previousLossesOk = (previousLosses?: PreviousLoss[] | null) => {
  if (previousLosses === undefined || previousLosses === null) return true;

  if (previousLosses.length > 2) return false;
  if (previousLosses.filter((loss) => loss.amount > 15000).length) return false;

  return true;
};
